interface Params {
  offerId: string;
}

export const getClaimOfferUrl = ({ offerId }: Params): string =>
  `/offers/${offerId}/claim_offer`;
